import * as React from 'react'
import { Col, Panel, Button } from 'react-bootstrap'
import { Article } from '../articlesContainer'

interface AddMorePanelProps {
	article: Article
	addVariation?: (articleId: string) => void
}

const AddMorePanel: React.SFC<AddMorePanelProps> = (props) => {
	const addVariation = () => {
		if (props.addVariation) {
			props.addVariation(props.article.uid)
		}
	}
	const renderAddMorePanel = () => {
		return (
			<Col className="text-center">
				<p>
					The more variations you have, the better your campaign will perform and the cheaper the CPC price
					will be!
				</p>
				<p>We recommend a minimum of three variations per article.</p>
				<p>
					<strong>Add more variations?</strong>
				</p>
				<Button
					style={{ marginLeft: 'auto', marginRight: 'auto' }}
					bsStyle="success"
					bsSize="small"
					onClick={addVariation}
				>
					Yes
				</Button>
			</Col>
		)
	}
	return (
		<Col sm={6} lg={4}>
			<Panel style={{ border: 0 }}>
				<Panel.Heading style={{ backgroundColor: 'transparent', border: 0 }}>&nbsp;</Panel.Heading>
				<Panel.Body
					style={{
						width: '100%',
						paddingTop: '120px',
						minHeight: '400px',
						borderRadius: '5px',
						border: '1px solid #ddd',
					}}
				>
					{renderAddMorePanel()}
				</Panel.Body>
			</Panel>
		</Col>
	)
}

export default AddMorePanel
